
export const peptideProducts = [
  {
    id: 1,
    name: 'BPC-157 Premium',
    category: 'Peptides',
    price: 89.99,
    image: 'https://certified-pep.com/cdn/shop/files/BPC-157_5mg_1024x1024.png?v=1729024088',
    description: 'Premium BPC-157 for enhanced recovery and tissue repair',
    benefits: ['Accelerated healing', 'Tissue repair', 'Anti-inflammatory'],
  },
  {
    id: 2,
    name: 'TB-500 Elite',
    category: 'Peptides',
    price: 94.99,
    image: 'https://certified-pep.com/cdn/shop/files/TB-500_5mg_1024x1024.png?v=1729024088',
    description: 'Elite TB-500 for muscle recovery and flexibility',
    benefits: ['Muscle recovery', 'Flexibility', 'Injury prevention'],
  },
  {
    id: 3,
    name: 'Ipamorelin Pro',
    category: 'Peptides',
    price: 79.99,
    image: 'https://certified-pep.com/cdn/shop/files/Ipamorelin_5mg_1024x1024.png?v=1729024088',
    description: 'Professional-grade Ipamorelin for growth hormone optimization',
    benefits: ['GH release', 'Fat loss', 'Muscle growth'],
  },
  {
    id: 4,
    name: 'CJC-1295 Advanced',
    category: 'Peptides',
    price: 84.99,
    image: 'https://certified-pep.com/cdn/shop/files/CJC-1295_5mg_1024x1024.png?v=1729024088',
    description: 'Advanced CJC-1295 for sustained growth hormone elevation',
    benefits: ['Sustained GH', 'Recovery', 'Body composition'],
  },
  {
    id: 5,
    name: 'Melanotan II',
    category: 'Peptides',
    price: 69.99,
    image: 'https://certified-pep.com/cdn/shop/files/Melanotan_II_10mg_1024x1024.png?v=1729024088',
    description: 'Premium Melanotan II for enhanced tanning and metabolism',
    benefits: ['Tanning', 'Appetite control', 'Libido support'],
  },
  {
    id: 6,
    name: 'PT-141 Premium',
    category: 'Peptides',
    price: 74.99,
    image: 'https://certified-pep.com/cdn/shop/files/PT-141_10mg_1024x1024.png?v=1729024088',
    description: 'Premium PT-141 for enhanced vitality and performance',
    benefits: ['Vitality', 'Performance', 'Wellness'],
  },
];

export const merchandiseProducts = [
  {
    id: 101,
    name: 'Sentinel Classic Tee',
    category: 'Apparel',
    price: 34.99,
    image: 'https://public.readdy.ai/ai/img_res/fea5715d1039d23a79c0c19577ad82f5.jpg',
    description: 'Premium cotton tee with Sentinel Brands logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 102,
    name: 'Sentinel Training Tee',
    category: 'Apparel',
    price: 39.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20electric%20blue%20athletic%20performance%20t-shirt%20with%20navy%20sentinel%20shield%20logo%20on%20chest%2C%20moisture%20wicking%20fabric%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20technical%20sportswear%20design%2C%20modern%20fit%2C%20flat%20lay%20composition%2C%20studio%20lighting&width=800&height=800&seq=tshirt002&orientation=squarish',
    description: 'Moisture-wicking performance tee for intense workouts',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 103,
    name: 'Sentinel Stealth Tee',
    category: 'Apparel',
    price: 36.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20cotton%20t-shirt%20with%20small%20electric%20blue%20sentinel%20shield%20logo%20embroidered%20on%20left%20chest%2C%20minimalist%20design%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20soft%20premium%20cotton%2C%20modern%20streetwear%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=tshirt003&orientation=squarish',
    description: 'Understated black tee with embroidered Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 104,
    name: 'Sentinel Graphic Tee',
    category: 'Apparel',
    price: 38.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20white%20cotton%20t-shirt%20with%20large%20navy%20blue%20sentinel%20shield%20logo%20and%20geometric%20graphic%20design%20on%20front%2C%20bold%20streetwear%20style%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20premium%20cotton%20fabric%2C%20modern%20urban%20aesthetic%2C%20front%20view&width=800&height=800&seq=tshirt004&orientation=squarish',
    description: 'Bold graphic tee with oversized Sentinel branding',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 105,
    name: 'Sentinel Varsity Tee',
    category: 'Apparel',
    price: 37.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20baby%20blue%20cotton%20t-shirt%20with%20navy%20sentinel%20shield%20varsity%20style%20logo%20and%20lettering%20on%20chest%2C%20collegiate%20athletic%20design%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20soft%20cotton%20fabric%2C%20retro%20sport%20aesthetic%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=tshirt005&orientation=squarish',
    description: 'Varsity-inspired tee with retro Sentinel branding',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 106,
    name: 'Sentinel Muscle Tee',
    category: 'Apparel',
    price: 32.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20sleeveless%20muscle%20tank%20top%20with%20white%20sentinel%20shield%20logo%20on%20chest%2C%20athletic%20cut%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20breathable%20cotton%20blend%2C%20gym%20workout%20aesthetic%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=tshirt006&orientation=squarish',
    description: 'Athletic muscle tee for training days',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 107,
    name: 'Sentinel Longline Tee',
    category: 'Apparel',
    price: 39.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20dark%20charcoal%20gray%20longline%20t-shirt%20with%20electric%20blue%20sentinel%20shield%20logo%20on%20chest%2C%20extended%20hem%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20premium%20cotton%2C%20modern%20urban%20streetwear%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=tshirt007&orientation=squarish',
    description: 'Extended longline tee with modern Sentinel branding',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 108,
    name: 'Sentinel Performance Hoodie',
    category: 'Apparel',
    price: 54.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20pullover%20hoodie%20with%20electric%20blue%20sentinel%20shield%20logo%20on%20chest%2C%20athletic%20fit%2C%20kangaroo%20pocket%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20high%20quality%20fleece%20material%2C%20modern%20activewear%20design%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=hoodie001&orientation=squarish',
    description: 'High-performance pullover hoodie for training and lifestyle',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 109,
    name: 'Sentinel Zip-Up Hoodie - Navy',
    category: 'Apparel',
    price: 54.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20full%20zip%20up%20hoodie%20with%20white%20sentinel%20shield%20logo%20embroidered%20on%20left%20chest%2C%20metal%20zipper%2C%20split%20kangaroo%20pockets%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20heavyweight%20fleece%2C%20modern%20athletic%20design%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=ziphood001&orientation=squarish',
    description: 'Full-zip hoodie in navy with embroidered Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 110,
    name: 'Sentinel Zip-Up Hoodie - Black',
    category: 'Apparel',
    price: 54.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20full%20zip%20up%20hoodie%20with%20electric%20blue%20sentinel%20shield%20logo%20embroidered%20on%20left%20chest%2C%20metal%20zipper%2C%20split%20kangaroo%20pockets%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20heavyweight%20fleece%2C%20sleek%20modern%20design%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=ziphood002&orientation=squarish',
    description: 'Full-zip hoodie in black with electric blue Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 111,
    name: 'Sentinel Crewneck Sweatshirt',
    category: 'Apparel',
    price: 49.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20baby%20blue%20crewneck%20sweatshirt%20with%20navy%20sentinel%20shield%20logo%20on%20chest%2C%20comfortable%20relaxed%20fit%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20soft%20cotton%20blend%20fabric%2C%20casual%20streetwear%20style%2C%20flat%20lay%2C%20studio%20lighting&width=800&height=800&seq=sweatshirt001&orientation=squarish',
    description: 'Classic crewneck with premium comfort',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 112,
    name: 'Sentinel Athletic Shorts - Navy',
    category: 'Apparel',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20athletic%20shorts%20with%20small%20white%20sentinel%20shield%20logo%20on%20left%20leg%2C%20elastic%20waistband%20with%20drawstring%2C%20lightweight%20breathable%20mesh%20fabric%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20modern%20gym%20shorts%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=shorts001&orientation=squarish',
    description: 'Lightweight athletic shorts with Sentinel branding',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 113,
    name: 'Sentinel Athletic Shorts - Black',
    category: 'Apparel',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20athletic%20shorts%20with%20electric%20blue%20sentinel%20shield%20logo%20on%20left%20leg%2C%20elastic%20waistband%20with%20drawstring%2C%20lightweight%20breathable%20mesh%20fabric%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20modern%20gym%20shorts%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=shorts002&orientation=squarish',
    description: 'Black athletic shorts with electric blue Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 114,
    name: 'Sentinel Athletic Shorts - Gray',
    category: 'Apparel',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20heather%20gray%20athletic%20shorts%20with%20navy%20sentinel%20shield%20logo%20on%20left%20leg%2C%20elastic%20waistband%20with%20drawstring%2C%20lightweight%20breathable%20mesh%20fabric%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20modern%20gym%20shorts%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=shorts003&orientation=squarish',
    description: 'Gray athletic shorts with navy Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 115,
    name: 'Sentinel Athletic Shorts - Electric Blue',
    category: 'Apparel',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20electric%20blue%20athletic%20shorts%20with%20white%20sentinel%20shield%20logo%20on%20left%20leg%2C%20elastic%20waistband%20with%20drawstring%2C%20lightweight%20breathable%20mesh%20fabric%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20modern%20gym%20shorts%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=shorts004&orientation=squarish',
    description: 'Electric blue athletic shorts with white Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 116,
    name: 'Sentinel Athletic Shorts - White',
    category: 'Apparel',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20white%20athletic%20shorts%20with%20navy%20sentinel%20shield%20logo%20on%20left%20leg%2C%20elastic%20waistband%20with%20drawstring%2C%20lightweight%20breathable%20mesh%20fabric%2C%20clean%20light%20gray%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20modern%20gym%20shorts%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=shorts005&orientation=squarish',
    description: 'Clean white athletic shorts with navy Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 117,
    name: 'Sentinel Jogger Sweats - Navy',
    category: 'Apparel',
    price: 49.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20jogger%20sweatpants%20with%20white%20sentinel%20shield%20logo%20on%20left%20thigh%2C%20tapered%20fit%2C%20elastic%20cuffs%2C%20drawstring%20waist%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20soft%20fleece%20fabric%2C%20modern%20athletic%20joggers%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=sweats001&orientation=squarish',
    description: 'Tapered jogger sweats in navy with Sentinel branding',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 118,
    name: 'Sentinel Jogger Sweats - Black',
    category: 'Apparel',
    price: 49.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20black%20jogger%20sweatpants%20with%20electric%20blue%20sentinel%20shield%20logo%20on%20left%20thigh%2C%20tapered%20fit%2C%20elastic%20cuffs%2C%20drawstring%20waist%2C%20clean%20white%20studio%20background%2C%20professional%20flat%20lay%20product%20photography%2C%20soft%20fleece%20fabric%2C%20modern%20athletic%20joggers%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=sweats002&orientation=squarish',
    description: 'Black jogger sweats with electric blue Sentinel logo',
    sizes: ['S', 'M', 'L', 'XL', 'XXL'],
  },
  {
    id: 119,
    name: 'Sentinel Snapback Hat',
    category: 'Accessories',
    price: 29.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20snapback%20hat%20with%20electric%20blue%20sentinel%20shield%20embroidered%20logo%2C%20structured%20crown%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20high%20quality%20cotton%20twill%2C%20modern%20streetwear%20cap%2C%20side%20angle%20view%2C%20studio%20lighting&width=800&height=800&seq=hat001&orientation=squarish',
    description: 'Structured snapback with embroidered logo',
    sizes: ['One Size'],
  },
  {
    id: 120,
    name: 'Sentinel Beanie',
    category: 'Accessories',
    price: 24.99,
    image: 'https://readdy.ai/api/search-image?query=premium%20navy%20blue%20knit%20beanie%20with%20white%20sentinel%20shield%20logo%20patch%2C%20soft%20acrylic%20fabric%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20modern%20winter%20accessory%2C%20minimalist%20design%2C%20front%20view%2C%20studio%20lighting&width=800&height=800&seq=beanie001&orientation=squarish',
    description: 'Warm knit beanie for cold weather training',
    sizes: ['One Size'],
  },
];

export const suppliesProducts = [
  {
    id: 201,
    name: '1mL Insulin Syringe 29G - 10 Pack',
    category: 'Supplies',
    subcategory: 'Syringes',
    price: 12.99,
    image: 'https://readdy.ai/api/search-image?query=pack%20of%20ten%201ml%20insulin%20syringes%20with%20orange%20caps%20and%2029%20gauge%20needles%2C%20medical%20grade%20disposable%20syringes%20neatly%20arranged%20on%20clean%20white%20studio%20background%2C%20professional%20medical%20product%20photography%2C%20sterile%20packaging%2C%20sharp%20studio%20lighting%2C%20top%20down%20flat%20lay%20view&width=800&height=800&seq=syringe001&orientation=squarish',
    description: 'Medical-grade 1mL insulin syringes with 29G needles, ideal for precise peptide dosing',
    details: ['29 Gauge needle', '1mL capacity', 'Sterile individually wrapped', '10 per pack'],
  },
  {
    id: 202,
    name: '1mL Insulin Syringe 30G - 10 Pack',
    category: 'Supplies',
    subcategory: 'Syringes',
    price: 13.99,
    image: 'https://readdy.ai/api/search-image?query=pack%20of%20ten%201ml%20insulin%20syringes%20with%20green%20caps%20and%20ultra%20fine%2030%20gauge%20needles%2C%20medical%20grade%20disposable%20syringes%20on%20clean%20white%20studio%20background%2C%20professional%20medical%20product%20photography%2C%20sterile%20sealed%20packaging%2C%20sharp%20studio%20lighting%2C%20flat%20lay%20arrangement&width=800&height=800&seq=syringe002&orientation=squarish',
    description: 'Ultra-fine 30G insulin syringes for virtually painless subcutaneous peptide injections',
    details: ['30 Gauge ultra-fine needle', '1mL capacity', 'Sterile individually wrapped', '10 per pack'],
  },
  {
    id: 203,
    name: '3mL Luer Lock Syringe 25G - 10 Pack',
    category: 'Supplies',
    subcategory: 'Syringes',
    price: 14.99,
    image: 'https://readdy.ai/api/search-image?query=pack%20of%20ten%203ml%20luer%20lock%20syringes%20with%20detachable%2025%20gauge%20needles%20and%20blue%20plunger%2C%20medical%20grade%20disposable%20syringes%20on%20clean%20white%20studio%20background%2C%20professional%20medical%20product%20photography%2C%20sterile%20packaging%2C%20sharp%20studio%20lighting%2C%20flat%20lay%20top%20view&width=800&height=800&seq=syringe003&orientation=squarish',
    description: 'Versatile 3mL luer lock syringes with 25G needles for reconstitution and larger volume draws',
    details: ['25 Gauge needle', '3mL capacity', 'Luer lock tip', 'Sterile individually wrapped', '10 per pack'],
  },
  {
    id: 204,
    name: '5mL Luer Lock Syringe 22G - 5 Pack',
    category: 'Supplies',
    subcategory: 'Syringes',
    price: 11.99,
    image: 'https://readdy.ai/api/search-image?query=pack%20of%20five%205ml%20luer%20lock%20syringes%20with%2022%20gauge%20needles%20and%20clear%20barrel%20markings%2C%20large%20medical%20grade%20disposable%20syringes%20on%20clean%20white%20studio%20background%2C%20professional%20medical%20product%20photography%2C%20sterile%20packaging%2C%20sharp%20studio%20lighting%2C%20flat%20lay%20arrangement&width=800&height=800&seq=syringe004&orientation=squarish',
    description: 'Large 5mL syringes with 22G needles, perfect for drawing and transferring BAC water',
    details: ['22 Gauge needle', '5mL capacity', 'Luer lock tip', 'Clear barrel markings', '5 per pack'],
  },
  {
    id: 205,
    name: 'Bacteriostatic Water 30mL',
    category: 'Supplies',
    subcategory: 'BAC Water',
    price: 18.99,
    image: 'https://readdy.ai/api/search-image?query=single%2030ml%20glass%20vial%20of%20bacteriostatic%20water%20with%20blue%20flip%20off%20cap%20and%20clear%20sterile%20liquid%20inside%2C%20pharmaceutical%20grade%20medical%20vial%20with%20professional%20label%2C%20clean%20white%20studio%20background%2C%20professional%20medical%20product%20photography%2C%20sharp%20studio%20lighting%2C%20front%20view&width=800&height=800&seq=bacwater001&orientation=squarish',
    description: 'Pharmaceutical-grade 30mL bacteriostatic water for safe peptide reconstitution',
    details: ['30mL sterile vial', '0.9% benzyl alcohol', 'USP grade', 'Multi-use vial', 'Flip-off cap'],
  },
  {
    id: 206,
    name: 'Bacteriostatic Water 60mL',
    category: 'Supplies',
    subcategory: 'BAC Water',
    price: 29.99,
    image: 'https://readdy.ai/api/search-image?query=single%2060ml%20large%20glass%20vial%20of%20bacteriostatic%20water%20with%20blue%20flip%20off%20cap%20and%20clear%20sterile%20liquid%20inside%2C%20pharmaceutical%20grade%20medical%20vial%20with%20professional%20label%2C%20clean%20white%20studio%20background%2C%20professional%20medical%20product%20photography%2C%20sharp%20studio%20lighting%2C%20front%20view&width=800&height=800&seq=bacwater002&orientation=squarish',
    description: 'Large 60mL bacteriostatic water vial for extended peptide reconstitution needs',
    details: ['60mL sterile vial', '0.9% benzyl alcohol', 'USP grade', 'Multi-use vial', 'Flip-off cap'],
  },
  {
    id: 207,
    name: 'Bacteriostatic Water 30mL - 3 Pack',
    category: 'Supplies',
    subcategory: 'BAC Water',
    price: 44.99,
    image: 'https://readdy.ai/api/search-image?query=three%2030ml%20glass%20vials%20of%20bacteriostatic%20water%20with%20blue%20flip%20off%20caps%20arranged%20in%20a%20row%2C%20pharmaceutical%20grade%20sterile%20water%20vials%20with%20professional%20labels%2C%20clean%20white%20studio%20background%2C%20professional%20medical%20product%20photography%2C%20sharp%20studio%20lighting%2C%20front%20view&width=800&height=800&seq=bacwater003&orientation=squarish',
    description: 'Value 3-pack of 30mL bacteriostatic water vials for multiple peptide reconstitutions',
    details: ['3x 30mL sterile vials', '0.9% benzyl alcohol', 'USP grade', 'Multi-use vials', 'Best value'],
  },
  {
    id: 208,
    name: 'Single Vial Protective Case',
    category: 'Supplies',
    subcategory: 'Cases',
    price: 16.99,
    image: 'https://readdy.ai/api/search-image?query=small%20navy%20blue%20hard%20shell%20protective%20carrying%20case%20for%20single%20peptide%20vial%20with%20foam%20insert%20cutout%20inside%2C%20zippered%20closure%2C%20compact%20medical%20vial%20storage%20case%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20sharp%20studio%20lighting%2C%20open%20case%20showing%20interior&width=800&height=800&seq=case001&orientation=squarish',
    description: 'Compact hard-shell case with foam insert to safely store and transport a single peptide vial',
    details: ['Hard-shell exterior', 'Custom foam insert', 'Zippered closure', 'Fits standard 10mL vials', 'Compact & portable'],
  },
  {
    id: 209,
    name: 'Multi-Vial Protective Case',
    category: 'Supplies',
    subcategory: 'Cases',
    price: 34.99,
    image: 'https://readdy.ai/api/search-image?query=medium%20navy%20blue%20hard%20shell%20protective%20carrying%20case%20for%20multiple%20peptide%20vials%20with%20custom%20foam%20insert%20holding%20six%20vials%2C%20zippered%20closure%2C%20organized%20medical%20vial%20storage%20case%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20sharp%20studio%20lighting%2C%20open%20case%20showing%20interior%20slots&width=800&height=800&seq=case002&orientation=squarish',
    description: 'Organized multi-vial case with foam slots for up to 6 peptide vials plus syringe storage',
    details: ['Holds up to 6 vials', 'Syringe compartment', 'Hard-shell protection', 'Zippered closure', 'Labeled slots'],
  },
  {
    id: 210,
    name: 'Complete Travel Kit Case',
    category: 'Supplies',
    subcategory: 'Cases',
    price: 49.99,
    image: 'https://readdy.ai/api/search-image?query=large%20premium%20navy%20blue%20and%20black%20hard%20shell%20travel%20case%20for%20peptide%20supplies%20with%20multiple%20compartments%20holding%20vials%20syringes%20and%20bac%20water%2C%20organized%20foam%20inserts%2C%20heavy%20duty%20zipper%2C%20professional%20medical%20travel%20kit%2C%20clean%20white%20studio%20background%2C%20professional%20product%20photography%2C%20sharp%20studio%20lighting%2C%20open%20case%20showing%20all%20compartments&width=800&height=800&seq=case003&orientation=squarish',
    description: 'All-in-one travel case with dedicated compartments for vials, syringes, BAC water, and alcohol swabs',
    details: ['Holds 8+ vials', 'Syringe organizer', 'BAC water slot', 'Alcohol swab pocket', 'TSA-friendly design', 'Heavy-duty zipper'],
  },
];

export const bundleProducts = [
  {
    id: 301,
    name: 'Recovery Starter Kit',
    category: 'Bundles',
    price: 159.99,
    originalPrice: 203.97,
    image: 'https://readdy.ai/api/search-image?query=premium%20peptide%20starter%20kit%20bundle%20with%20two%20glass%20vials%20of%20BPC-157%20and%20TB-500%20peptides%20plus%20bacteriostatic%20water%20vial%20arranged%20together%20on%20sleek%20dark%20navy%20surface%2C%20professional%20pharmaceutical%20product%20photography%2C%20clean%20minimal%20composition%2C%20soft%20studio%20lighting%2C%20elegant%20medical%20aesthetic%2C%20top%20down%20view&width=800&height=800&seq=bundle001&orientation=squarish',
    description: 'The ultimate recovery duo — BPC-157 + TB-500 + BAC Water. Everything you need to start your healing journey.',
    benefits: ['Accelerated healing', 'Muscle recovery', 'Tissue repair', 'Complete kit'],
    includes: ['BPC-157 5mg', 'TB-500 5mg', 'BAC Water 30mL'],
    savings: 43.98,
  },
  {
    id: 302,
    name: 'Growth Optimization Bundle',
    category: 'Bundles',
    price: 149.99,
    originalPrice: 183.97,
    image: 'https://readdy.ai/api/search-image?query=premium%20peptide%20bundle%20with%20two%20glass%20vials%20of%20Ipamorelin%20and%20CJC-1295%20peptides%20plus%20bacteriostatic%20water%20vial%20arranged%20on%20dark%20navy%20surface%20with%20gold%20accent%20lighting%2C%20professional%20pharmaceutical%20product%20photography%2C%20clean%20minimal%20composition%2C%20elegant%20medical%20aesthetic%2C%20top%20down%20view&width=800&height=800&seq=bundle002&orientation=squarish',
    description: 'Maximize growth hormone release with the synergistic Ipamorelin + CJC-1295 stack plus BAC Water.',
    benefits: ['GH optimization', 'Fat loss', 'Lean muscle', 'Synergistic stack'],
    includes: ['Ipamorelin 5mg', 'CJC-1295 5mg', 'BAC Water 30mL'],
    savings: 33.98,
  },
  {
    id: 303,
    name: 'Complete Peptide Starter Kit',
    category: 'Bundles',
    price: 249.99,
    originalPrice: 331.95,
    image: 'https://readdy.ai/api/search-image?query=premium%20complete%20peptide%20starter%20kit%20with%20four%20glass%20vials%20of%20peptides%20and%20bacteriostatic%20water%20plus%20syringes%20and%20protective%20case%20arranged%20on%20dark%20navy%20surface%2C%20professional%20pharmaceutical%20product%20photography%2C%20luxury%20presentation%2C%20clean%20minimal%20composition%2C%20soft%20studio%20lighting%2C%20top%20down%20flat%20lay%20view&width=800&height=800&seq=bundle003&orientation=squarish',
    description: 'Everything a beginner needs — 4 top peptides, BAC Water, syringes, and a protective case all in one box.',
    benefits: ['Recovery', 'Growth', 'Performance', 'All-in-one'],
    includes: ['BPC-157 5mg', 'TB-500 5mg', 'Ipamorelin 5mg', 'CJC-1295 5mg', 'BAC Water 30mL', '1mL Syringes 10-pack', 'Single Vial Case'],
    savings: 81.96,
  },
  {
    id: 304,
    name: 'Recovery Pro Bundle',
    category: 'Bundles',
    price: 219.99,
    originalPrice: 282.95,
    image: 'https://readdy.ai/api/search-image?query=premium%20pro%20recovery%20peptide%20bundle%20with%20three%20glass%20vials%20of%20BPC-157%20and%20TB-500%20peptides%20plus%20large%20bacteriostatic%20water%20and%20syringe%20pack%20on%20dark%20navy%20surface%2C%20professional%20pharmaceutical%20product%20photography%2C%20clean%20minimal%20composition%2C%20warm%20studio%20lighting%2C%20elegant%20medical%20aesthetic%2C%20top%20down%20view&width=800&height=800&seq=bundle004&orientation=squarish',
    description: 'Extended recovery protocol — double BPC-157 + TB-500 with 60mL BAC Water and syringes for a full 8-week cycle.',
    benefits: ['8-week cycle', 'Deep tissue repair', 'Joint support', 'Extended protocol'],
    includes: ['BPC-157 5mg x2', 'TB-500 5mg', 'BAC Water 60mL', '1mL Syringes 10-pack'],
    savings: 62.96,
  },
  {
    id: 305,
    name: 'Lean & Shred Stack',
    category: 'Bundles',
    price: 139.99,
    originalPrice: 174.97,
    image: 'https://readdy.ai/api/search-image?query=premium%20lean%20body%20peptide%20stack%20bundle%20with%20two%20glass%20vials%20of%20Ipamorelin%20and%20Melanotan%20II%20peptides%20plus%20bacteriostatic%20water%20on%20dark%20navy%20surface%20with%20cool%20lighting%2C%20professional%20pharmaceutical%20product%20photography%2C%20clean%20minimal%20composition%2C%20modern%20aesthetic%2C%20top%20down%20view&width=800&height=800&seq=bundle005&orientation=squarish',
    description: 'Torch fat and optimize body composition with Ipamorelin + Melanotan II plus BAC Water.',
    benefits: ['Fat burning', 'Metabolism boost', 'Body composition', 'Appetite control'],
    includes: ['Ipamorelin 5mg', 'Melanotan II 10mg', 'BAC Water 30mL'],
    savings: 34.98,
  },
  {
    id: 306,
    name: 'Ultimate Performance Kit',
    category: 'Bundles',
    price: 349.99,
    originalPrice: 468.90,
    image: 'https://readdy.ai/api/search-image?query=premium%20ultimate%20peptide%20performance%20kit%20with%20six%20glass%20vials%20of%20various%20peptides%20plus%20bacteriostatic%20water%20syringes%20and%20large%20travel%20case%20arranged%20on%20dark%20navy%20surface%20with%20dramatic%20lighting%2C%20professional%20pharmaceutical%20product%20photography%2C%20luxury%20presentation%2C%20clean%20composition%2C%20top%20down%20flat%20lay%20view&width=800&height=800&seq=bundle006&orientation=squarish',
    description: 'The complete arsenal — all 6 peptides, BAC Water 3-pack, syringes, and a travel case. Maximum savings for serious users.',
    benefits: ['All 6 peptides', 'Full supply kit', 'Maximum savings', 'Travel ready'],
    includes: ['BPC-157 5mg', 'TB-500 5mg', 'Ipamorelin 5mg', 'CJC-1295 5mg', 'Melanotan II 10mg', 'PT-141 10mg', 'BAC Water 30mL 3-Pack', '1mL Syringes 10-pack', 'Complete Travel Kit Case'],
    savings: 118.91,
  },
  {
    id: 307,
    name: 'Vitality & Wellness Duo',
    category: 'Bundles',
    price: 129.99,
    originalPrice: 163.97,
    image: 'https://readdy.ai/api/search-image?query=premium%20wellness%20peptide%20duo%20bundle%20with%20two%20glass%20vials%20of%20PT-141%20and%20Melanotan%20II%20peptides%20plus%20bacteriostatic%20water%20on%20dark%20navy%20surface%20with%20warm%20ambient%20lighting%2C%20professional%20pharmaceutical%20product%20photography%2C%20clean%20minimal%20composition%2C%20elegant%20aesthetic%2C%20top%20down%20view&width=800&height=800&seq=bundle007&orientation=squarish',
    description: 'Boost vitality and confidence with the PT-141 + Melanotan II combo plus BAC Water.',
    benefits: ['Vitality boost', 'Confidence', 'Wellness', 'Performance'],
    includes: ['PT-141 10mg', 'Melanotan II 10mg', 'BAC Water 30mL'],
    savings: 33.98,
  },
  {
    id: 308,
    name: 'Supply Essentials Pack',
    category: 'Bundles',
    price: 74.99,
    originalPrice: 96.96,
    image: 'https://readdy.ai/api/search-image?query=premium%20peptide%20supply%20essentials%20pack%20with%20bacteriostatic%20water%20vials%20insulin%20syringes%20and%20protective%20vial%20case%20arranged%20neatly%20on%20dark%20navy%20surface%2C%20professional%20medical%20product%20photography%2C%20clean%20minimal%20composition%2C%20organized%20flat%20lay%2C%20soft%20studio%20lighting%2C%20top%20down%20view&width=800&height=800&seq=bundle008&orientation=squarish',
    description: 'Stock up on essentials — BAC Water 3-pack, two syringe packs, and a multi-vial case at a bundled price.',
    benefits: ['Best value supplies', 'Everything you need', 'Multi-vial storage', 'Bulk savings'],
    includes: ['BAC Water 30mL 3-Pack', '1mL Syringes 29G 10-pack', '1mL Syringes 30G 10-pack', 'Multi-Vial Case'],
    savings: 21.97,
  },
];
